import { render, staticRenderFns } from "./InputRangeDouble.vue?vue&type=template&id=671bdbf1&lang=pug"
import script from "./InputRangeDouble.vue?vue&type=script&lang=js"
export * from "./InputRangeDouble.vue?vue&type=script&lang=js"
import style0 from "./InputRangeDouble.vue?vue&type=style&index=0&id=671bdbf1&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports